import { Link } from "react-router-dom";
import { Instagram, Music2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import logo from "@/assets/szn-footer.webp";

export default function FooterLegal() {
  const { t } = useLang();
  const f = t.footer;
  const lg = f.legal;

  return (
    <footer id="footer" className="bg-[#0f1e2c] py-16 text-[#F6F1E8]" data-testid="section-footer">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <img src={logo} alt="SZN Seazoner Lifestyle" className="w-44" />
            <p className="mt-4 max-w-xs text-sm text-[#F6F1E8]/60">{f.tagline}</p>
            <div className="mt-5 flex gap-3">
              <a href="#hero" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-full border border-[#F6F1E8]/25 transition-colors hover:border-[#EA7A4F]">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="#hero" aria-label="TikTok" className="flex h-9 w-9 items-center justify-center rounded-full border border-[#F6F1E8]/25 transition-colors hover:border-[#EA7A4F]">
                <Music2 className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-widest text-[#3F9BA6]">{f.colTrip}</h4>
            <ul className="mt-4 space-y-2 text-sm text-[#F6F1E8]/70">
              {f.links.map(([label, href]) => (
                <li key={href}><a href={href} className="hover:text-[#EA7A4F]">{label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-widest text-[#3F9BA6]">{f.colLegal}</h4>
            <div className="mt-4 space-y-1 text-sm text-[#F6F1E8]/70" data-testid="legal-block">
              <p>{lg.soldBy}</p>
              <p className="font-semibold text-[#F6F1E8]">{lg.company}</p>
              <p>{lg.atout} <span className="italic text-[#F6F1E8]/50">{lg.toComplete}</span></p>
              <p>{lg.guarantee} <span className="italic text-[#F6F1E8]/50">{lg.toCompleteShort}</span></p>
              <p>{lg.insurance} <span className="italic text-[#F6F1E8]/50">{lg.toCompleteShort}</span></p>
            </div>
            <ul className="mt-4 space-y-2 text-sm text-[#F6F1E8]/70">
              <li>
                <Link to="/mentions-legales" className="underline decoration-[#EA7A4F] hover:text-[#EA7A4F]" data-testid="footer-mentions">
                  {f.mentions}
                </Link>
              </li>
              <li>
                <Link to="/confidentialite" className="underline decoration-[#EA7A4F] hover:text-[#EA7A4F]" data-testid="footer-privacy">
                  {f.privacy}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-[#F6F1E8]/15 pt-6 text-center text-xs text-[#F6F1E8]/45">
          <p>© {new Date().getFullYear()} SZN TRIP · {f.rights}</p>
        </div>
      </div>
    </footer>
  );
}
